import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import { Common, Mobile } from 'vue-superset'
import 'vant/lib/index.css'
import './assets/css/vant.cover.css'
import './assets/css/global.css'
import * as filters from './common/filters' // global filters
import qrcode from 'vue-qrcode-directive' // 二维码
import animated from 'animate.css' // animate.css
import clipboard from 'clipboard'
import Staticdata from './common/staticdata'

// 全局组件导入
import appHeader from './components/appHeader'
import dataNothing from './components/nothing.vue'
import privacy from './components/privacy.vue'
import conditions from './components/conditions.vue'

// 全局组件注册
Vue.component('app-header', appHeader)
Vue.component('data-nothing', dataNothing)
Vue.component('data-privacy', privacy)
Vue.component('data-conditions', conditions)
Vue.prototype.$clipboard = clipboard

Vue.use(Vant)
Vue.use(VueI18n)
Vue.use(Common)
Vue.use(Mobile)
Vue.use(qrcode)
Vue.use(animated)
Vue.config.productionTip = false

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.prototype.$Staticdata = Staticdata

// 判断浏览器语言 并根据浏览器语言设置页面语言
// let lang = navigator.language || navigator.userLanguage
// lang = lang.substr(0, 2)
const i18n = new VueI18n({
  // locale: lang === 'zh' ? 'zh' : 'en',
  locale: 'en',
  messages: {
    'zh': require('@/assets/languages/zh.json'),
    'en': require('@/assets/languages/en.json')
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // document.title = to.meta.title
    // if (to.meta.title === 'home') {
    //   document.title = i18n.lang === 'en' ? i18n.messages.en.common.home : i18n.messages.zh.common.home
    // } else {
    //   document.title = i18n.lang === 'en' ? i18n.messages.en.common.lang : i18n.messages.zh.common.lang
    // }
  }
  next()
})

new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
